import { useEffect, useState } from 'react';
import axios from 'axios';
import { LockKeyhole } from 'lucide-react';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { HoursClosureDialog } from './HoursClosureDialog';
import { apiError } from './shared';
import { notifyInternalChange } from './useInternalRefresh';

export const HoursClosurePanel = ({ employees, month, onSaved }) => {
  const [selected, setSelected] = useState('');
  const [record, setRecord] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { setRecord(null); setError(''); }, [month]);
  const load = async () => {
    setBusy(true); setError('');
    try { const { data } = await axios.get(`${API}/internal-staff/hours-closures/${selected}/${month}`, { withCredentials: true }); setRecord(data); }
    catch (e) { setError(apiError(e)); } finally { setBusy(false); }
  };
  return <section className="border-y py-5 space-y-3" data-testid="hours-closure-panel">
    <h2 className="text-lg font-semibold flex gap-2 items-center" data-testid="hours-closure-panel-title"><LockKeyhole className="w-4 h-4" />Clôture des heures DSP</h2>
    <p className="text-sm text-slate-600" data-testid="hours-closure-panel-month">Mois complet : {month} · Super Admin</p>
    <div className="flex flex-wrap items-end gap-3"><label className="text-sm flex-1 min-w-0 max-w-md">Dispatcher<select value={selected} disabled={busy} onChange={e => { setSelected(e.target.value); setError(''); }} className="w-full block border p-2 rounded-md bg-white mt-1" data-testid="hours-closure-dispatcher-select"><option value="">Choisir un dispatcher</option>{employees.map(p => <option key={p.user_id} value={p.user_id}>{p.name}{!p.active ? ' · désactivé' : ''}</option>)}</select></label><Button variant="outline" disabled={!selected || busy} onClick={load} data-testid="hours-closure-open-button">{busy ? 'Chargement…' : 'Consulter / préparer la clôture'}</Button></div>
    {error && <p role="alert" className="text-sm text-red-700" data-testid="hours-closure-panel-error">{error}</p>}
    {record && <HoursClosureDialog initial={record} onClose={() => setRecord(null)} onSaved={() => { notifyInternalChange(); onSaved(); }} />}
  </section>;
};